import imagesLoaded from 'imagesloaded';
import { Events } from '../../common/config/api';
import { keyboardTrap } from '../utils/formUtils';

/**
 * Overlays
 */

export default (function(w, d, $, undefined) {
  'use strict';

  /**
   * Default options
   */

  var config = {
      prefix: 'xO-',
      oClass: 'xOverlay',
      iClass: 'xOverlayInner xDetailContainer',
      cClass: 'xOverlayContent',
      static: 'content',
    },
    oIndex = 0,
    oCache = {},
    /**
     * Overlay class
     */

    Overlay = function(id, options) {
      this.id = id;
      _.extend(this, options);
      if (this.url) {
        ajaxContent.call(this);
      }
      createMarkup.call(this);
    },
    /**
     * modify an existing overlay, or create new overlay, add to DOM and trigger a .show()
     */

    createOverlay = function(options) {
      var id, obj, cache, o;
      if (!NGX.context.isFB) {
        // Attempt to get outer page's positioning/sizing data and store in app state
        if (NGX.App.state.framed) {
          NGX.App.api.messageParent({ action: 'getPageInfo' }, function(info) {
            NGX.App.state.pageInfo = info;
          });
        } else {
          NGX.App.state.pageInfo = {
            // We're not framed, so use the current frame's positioning/sizing data
            clientHeight: Math.max(document.documentElement.clientHeight, window.innerHeight || 0),
            scrollTop:
              window.pageYOffset !== undefined ?
                window.pageYOffset :
                (document.documentElement || document.body.parentNode || document.body).scrollTop,
            offsetTop: 0,
          };
        }
      } else {
        if (NGX.App.state.fbLoaded && FB) {
          // We're in Facebook, get the positioning/sizing data from the SDK
          FB.Canvas.getPageInfo(function(info) {
            NGX.App.state.pageInfo = info;
          });
        }
      }

      if (options) {
        if (options.type === config.static) {
          cache = _.where(oCache, { type: config.static });
          // cached match found
          if (cache.length > 0) {
            o = cache[0];
            o.content = options.content || false;
            o.url = options.url || false;
            // o.url takes priority over o.content, but will fail-over to the content if the AJAX request fails
            if (o.url) {
              return ajaxContent.call(o);
            } else if (o.content) {
              return updateContent.call(o);
            }
            // no content of any description provided. do nothing.
            return false;
          }
        }
        // create the overlay content if there is nothing to update
        if (options.id) {
          id = options.id;
        } else {
          id = config.prefix + ++oIndex;
        }
        obj = oCache[id] = new Overlay(id, options);
        return obj;
      }
      // no options provided
      return false;
    },
    /**
     * get overlay object by element ID.
     * you can specify a property as a second param, if that prop does not exist it returns false.
     */

    getOverlay = function(id, prop) {
      var oObj = oCache[id];
      if (!oObj) {
        return false;
      }
      return prop ? oObj[prop] || false : oObj;
    },
    /**
     * retrieve URL
     */

    ajaxContent = function() {
      var _self = this;
      $.ajax({
        url:      this.url,
        dataType: 'html',
      })
        .fail(function(xhr, err, msg) {
          if (!_self.content) {
            _self.content =
              '<div class="' +
              config.oClass +
              '-error"><h1>' +
              err +
              '</h1><p>' +
              msg +
              '</p><button class="xAction xActionCloseOverlay"><span>Close</span></button></span></div>';
          }
        })
        .done(function(response) {
          if (response.content) {
            _self.content = response.content[0];
          } else {
            _self.content = response;
          }
        })
        .complete(function() {
          updateContent.call(_self);
        });
      return _self;
    },
    /**
     * update the content value of the Overlay model
     */

    updateContent = function() {
      var _self = this;
      // if a template is present
      if (this.template) {
        // create handlebars template
        if (typeof this.template !== 'function') {
          this.template = Handlebars.compile(this.template);
        }
        // if passed an object as content, use that to populate the template
        if (_.isObject(this.content)) {
          this.content = this.template(this.content);
        } else {
          // otherwise use the overview object itself
          this.content = this.template(this);
        }
      } else if (this.view) {
        this.content = this.view.render().$el;
      }

      // populate the overlay
      this.$contentWrapper.html(this.content);
      // trigger the callback
      if (this.callback && this.callback.constructor === Function) {
        this.callback.call(this);
      }
      keyboardTrap(this.$el.get(0)); // Creates a keyboard trap around the overlay
      // trigger the global event
      NGX.App.Events.trigger(Events.OVERLAY_READY, this);
      // position it as best we can - [SG] Once images are loaded
      imagesLoaded(_self.el, function() {
        _self.center.call(_self);
      });
      // Disabling the scrolling for the body (otherwise 2 scrollbars appear when we have long overlay)
      d.body.style.overflow = 'hidden';
      // return the overlay object
      return this;
    },
    /**
     * Create a context sensitive close button;
     * @param type
     * @returns {*}
     */

    createCloseButtons = function(type) {
      var _self = this;

      var toolbar = d.createElement('div'),
        outer,
        middle;

      // Only create close buttons if not explicitly disabled in options.
      if (_self.disableUIClose !== true) {
        toolbar.setAttribute(
          'class',
          'xActionContainer xActionClose has' + type.charAt(0).toUpperCase() + type.slice(1)
        );

        if (type == 'button') {
          // Allow main close button to be hidden independently of close icon.
          if (_self.hideCloseButton !== true) {
            outer = d.createElement('div');
            middle = d.createElement('span');
            outer.setAttribute('class', 'xButton xAction xActionCloseOverlay');
            //outer.setAttribute('type','button');
            middle.innerHTML = NGX.lang.get('buttons.overlayClose');
            middle.setAttribute('tabindex', '0');
            middle.setAttribute('aria-label', NGX.lang.get('buttons.overlayClose'));
            middle.setAttribute('role', 'button');
          }
        } else {
          // Create <a> based close button
          outer = d.createElement('a');
          middle = d.createElement('i');
          outer.setAttribute('class', 'xIconButton xAction xActionCloseOverlay');
          outer.setAttribute('href', '#');
          outer.setAttribute('tabindex', '-1');
          outer.setAttribute('role', 'button');
          middle.setAttribute('class', 'xIcon xIconClose');
          middle.setAttribute('tabindex', '0');
          middle.setAttribute('aria-label', NGX.lang.get('buttons.overlayClose'));
          middle.setAttribute('role', 'button');
        }

        if (this.type == 'state') {
          // Add ngx-action for reverting to previous state in stateAsOverlay
          middle.setAttribute('data-ngx-action', 'exec:statePrev');
        }

        if (outer) {
          outer.appendChild(middle);
          toolbar.appendChild(outer);
        }
      }

      return toolbar;
    },
    /**
     * Build the markup, bind events and attach to DOM.
     * call in scope but don't prototype because we don't want to expose this.
     */

    createMarkup = function() {
      var _self = this,
        el = (this.el = d.createElement('div')),
        ir = (this.inner = d.createElement('div')),
        contentWrapper = (this.contentWrapper = d.createElement('div')),
        $e = (this.$el = $(el)),
        $i = (this.$inner = $(ir)),
        $contentWrapper = (this.$contentWrapper = $(contentWrapper)),
        preOverlayFocus = _self.focusOnClose || d.activeElement; // Reference of element to return focus to on close

      // setup the HTML element
      el.id = this.id;
      el.setAttribute('class', config.oClass + (_self.type ? ' ' + config.oClass + '-' + _self.type : ''));
      ir.setAttribute('class', config.iClass);
      ir.setAttribute('tabindex', '0'); // Makes the inner overlay focusable
      ir.setAttribute('role', 'dialog');
      ir.setAttribute('aria-modal', 'true');
      // Adding WAI-ARIA attrs
      ir.setAttribute('aria-labelledby', 'xInviteModalHeader');
      ir.setAttribute('aria-describedby', 'xInviteModalContent');
      contentWrapper.setAttribute('class', 'xOverlayContent');
      if (_self.type) el.setAttribute('data-type', _self.type);
      ir.appendChild(createCloseButtons.call(_self, 'icon'));
      ir.appendChild(contentWrapper);
      ir.appendChild(createCloseButtons.call(_self, 'button'));
      el.appendChild(ir);
      ir.style.opacity = '0';

      // event binds
      if (_self.type !== 'state' && _self.disableUIClose !== true) {
        $e.on('click', function(ev) {
          if ($(ev.target).hasClass('xOverlay')) {
            _self.destroy();
          } else {
            var $this = $(_self),
              $promo = $this.parents('.xPromotion');

            if ($promo) {
              // Only track link clicks as promo if inside a promo!
              if ($this.hasClass('xCTASecondary')) {
                NGX.Insights.track('click:secondaryCta', { p: $promo.attr('data-ngx-id') });
              } else if ($this.hasClass('xCTA')) {
                NGX.Insights.track('click:promo', { p: $promo.attr('data-ngx-id') });
              }
            }
          }
        });
      }

      // Only apply event listeners to close overlay if not explicitly disabled in options.
      if (_self.disableUIClose !== true) {
        var closeOverlaySelector = '.xActionCloseOverlay span, .xActionCloseOverlay .xIconClose';
        var closeOverlayCallback = function(e) {
          e.preventDefault();
          e.stopPropagation();

          _self.hide();
          _self.destroy();
          if (preOverlayFocus) preOverlayFocus.focus();
        };

        $i.on('click', closeOverlaySelector, closeOverlayCallback);
        $i.on('keydown', closeOverlaySelector, function(e) {
          if (e.keyCode === 13 || e.keyCode === 32) {
            closeOverlayCallback.call(this, e);
            NGX.App.api.actionClick.call(this, e);
          }
        });

        // For accessibily and screen readers. There is not a way to hide the outer anchor tag from
        // screen readers. When navigating with SRs they do not navigate to the inner icon button.
        $i.on('keydown', '.xActionCloseOverlay', function(e) {
          // Call close handler only in case of "back" or "Esc" keys
          if ([4,27].includes(e.keyCode))
            $(document.querySelector(closeOverlaySelector)).keydown(e);
        });
        $i.on('click', '.xActionCloseOverlay', function(e) {
          $(document.querySelector(closeOverlaySelector)).click(e);
        });

        // enable data attributes (propagation from overlay mask close prevents this)
        $i.on('click', '[data-ngx-action]', function(e) {
          NGX.App.api.actionClick.call(this, e);
        });

        // allow closing of overlay with keypress
        $(el).keydown(function(e) {
          var o;
          // 4  = android back button
          // 27 = desktop escape key
          if (e.keyCode == 4 || e.keyCode == 27) {
            o = oCache[_self.id || config.prefix + oIndex];
            if (o) {
              e.preventDefault();
              o.hide();
              o.destroy();
              NGX.App.api.actionClick.call($(closeOverlaySelector, el).get(0), e);
            }
          }
        });
      }

      // append to the DOM
      d.body.appendChild(el);

      // this will trigger a reflow/repaint but we want to trigger the callback and 'overlay:open' event in the update method after it's attached to the DOM
      updateContent.call(_self);
    };

  // Using opacity to show and hide allows us to animate a fade in with CSS
  Overlay.prototype.show = function() {
    this.el.style.opacity = '1';
    return this;
  };

  Overlay.prototype.center = function() {
    var _self = this,
      positionInner = function(info) {
        /**
         * Super complicated method for positioning the overlay in the middle of the page inside and outside of iframes
         * @params {Object} info : positioning info (size, scrollTop etc)
         */
        if ('undefined' === typeof info) {
          info = NGX.App.api.messageParent({ action: 'getpageinfo' });
        }
        var _info = info || {};
        _self.inner.style.maxHeight = 'none';

        // If preview mode, we also need to take into account the scrollY off the fixed height wrapper div (not the actual window, this never scrolls!).
        if (NGX.context.isPreview) {
          try {
            var parentWin = window.parent;
            var selectedPreviewFrameId = $(parentWin.document)
              .find('#campaignPageNav .state-preview.selected')
              .attr('data-state');
            var previewFrameWrapperScrollY = $(parentWin.document)
              .find('#preview-pane-' + selectedPreviewFrameId)
              .scrollTop();
            _info.scrollTop += previewFrameWrapperScrollY;
          } catch (exception) {}
        }

        var st = _info.scrollTop,
          ch = _info.clientHeight,
          ih = _self.$inner.outerHeight(),
          ot = _info.offsetTop,
          total;

        var vTop, vMiddle, vBottom;

        if (NGX.App.state.framed) {
          vTop = st; // Top of iframe
          vBottom = vTop + ch; // Bottom of iframe
          vMiddle = (vBottom - vTop) / 2 + vTop; // Middle of iframe
          total = vMiddle - ih / 2 - ot; // Calculated top position of modal
          var docHeight = $(d).outerHeight();

          // If the iframe is smaller than the content, you're gonna have to try to grow it
          if (ih > docHeight) {
            d.body.style.minHeight = ih + 40 + 'px';
            NGX.App.api.resizeParent();
            total = 0;
          }
          // If the bottom of the iframe would be cut off, move to top of frame
          if (total > docHeight || total + ih > docHeight) total = docHeight - (ih + 40);
        } else {
          // Not in a frame
          total = ch / 2 - ih / 2;
        }

        // position the overlay
        _self.inner.style.top = Math.max(30, Math.round(total)) + 'px';
        // show the overlay
        _self.inner.style.opacity = '1';
      };

    // If we are in Facebook.
    if (NGX.context.isFB && NGX.App.state.framed) {
      _self.$el.addClass('xPositionFrame');

      // facebook tab or tab in canvas
      NGX.Util.requireSDK(log.getDebugLevel() ? 'fbdebug' : 'fb', function() {
        FB.Canvas.getPageInfo(positionInner);
      });

      // If we are in a normal website embed (and more importantly the Embed API has been loaded in the parent window).
    } else if (NGX.App.state.useApi) {
      // Send a page info request to the parent, then reposition the overlay
      NGX.App.api.messageParent({ action: 'getpageinfo' }, function(info) {
        positionInner(info);
      });
      // ...and show it
      _self.inner.style.opacity = '1';

      // If we are not embedded at all.
    } else {
      // outside FB
      _self.$el.addClass('xPositionScreen');
      setTimeout(function() {
        // Yuk - SG
        positionInner(NGX.App.state.pageInfo);
      }, 75);
    }
    return this;
  };

  Overlay.prototype.hide = function() {
    // When hiding the overlay, we will allow the scrolling for all content
    d.body.style.overflow = 'visible';
    NGX.App.Events.trigger(Events.OVERLAY_HIDDEN);
    // Do it this way for CSS fadeOut transition
    this.el.style.opacity = '0';
    return this;
  };

  Overlay.prototype.destroy = function() {
    d.body.style.overflow = 'visible';
    if (d.body.contains(this.el)) d.body.removeChild(this.el);
    d.body.style.minHeight = '';
    delete oCache[this.id];
    --oIndex;
    // if an onclose fn has been specified trigger now
    if (typeof this.onclose === 'function') {
      return this.onclose();
    }
    NGX.App.Events.trigger(Events.OVERLAY_DESTROYED);
    NGX.App.api.resizeParent();
    return null;
  };

  // Public API
  return {
    get:    getOverlay,
    create: createOverlay,
    cache:  {},
  };
})(window, document, $);
